/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const PagesForMac32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <mask
            id="prefix__a"
            style={{
                maskType: 'alpha',
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={32}
            height={32}
        >
            <path
                d="M32 10.01c0-.382 0-.764-.002-1.147a45.72 45.72 0 00-.015-.965c-.018-.701-.06-1.408-.184-2.102a7.094 7.094 0 00-.659-1.998A6.722 6.722 0 0028.202.86 7.092 7.092 0 0026.204.2c-.693-.124-1.4-.166-2.102-.184a46.263 46.263 0 00-.965-.015C22.754 0 22.372 0 21.99 0H10.01c-.382 0-.764 0-1.147.002-.322.002-.643.006-.965.015-.702.018-1.409.06-2.103.184A7.092 7.092 0 003.798.86 6.719 6.719 0 00.86 3.798 7.092 7.092 0 00.2 5.796c-.124.694-.166 1.4-.184 2.102-.01.322-.013.643-.015.965C0 9.246 0 9.628 0 10.01v11.98c0 .382 0 .764.002 1.147.002.322.006.643.015.965.018.701.06 1.409.184 2.102.127.704.333 1.359.659 1.998a6.72 6.72 0 002.938 2.938c.639.326 1.294.532 1.997.659.694.124 1.401.166 2.103.184.322.01.643.013.965.015.383.002.765.002 1.147.002h11.98c.382 0 .764 0 1.147-.002.322-.002.643-.006.965-.015.702-.018 1.409-.06 2.102-.184a7.093 7.093 0 001.998-.659 6.719 6.719 0 002.938-2.938c.326-.64.532-1.294.659-1.998.124-.694.166-1.4.184-2.102.01-.322.013-.643.015-.965.002-.383.002-.765.002-1.147V10.01z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#prefix__a)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 10.01c0-.382 0-.764-.003-1.147a45.72 45.72 0 00-.014-.965c-.019-.701-.06-1.408-.185-2.102a7.09 7.09 0 00-.658-1.998A6.722 6.722 0 0028.202.86a7.092 7.092 0 00-1.998-.658c-.693-.125-1.4-.166-2.102-.185a46.274 46.274 0 00-.966-.015C22.754 0 22.372 0 21.99 0H10.01c-.382 0-.764 0-1.147.002-.322.002-.643.006-.965.015-.702.019-1.41.06-2.103.185A7.092 7.092 0 003.798.86 6.719 6.719 0 00.86 3.798 7.093 7.093 0 00.2 5.796c-.124.694-.166 1.4-.184 2.102-.01.322-.013.643-.015.965C0 9.246 0 9.628 0 10.01v11.98c0 .382 0 .764.002 1.146.002.322.006.644.015.966.018.701.06 1.408.184 2.101.127.704.333 1.36.659 2a6.717 6.717 0 002.938 2.937c.639.325 1.294.532 1.997.658.694.125 1.401.166 2.103.185.322.009.643.013.965.015.383.002.765.002 1.147.002h11.98c.382 0 .764 0 1.146-.002.322-.002.644-.006.966-.015.701-.019 1.409-.06 2.102-.185a7.087 7.087 0 001.998-.658 6.719 6.719 0 002.938-2.938 7.09 7.09 0 00.658-1.999c.125-.693.166-1.4.185-2.101.009-.322.013-.644.014-.966.003-.382.003-.764.003-1.146V10.01z"
            />
            <path d="M32 0H0v32h32V0z" fill="url(#prefix__paint0_linear_56_33)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.402 26.4H9.2l-2.4 1.067h19.602a.532.532 0 00.532-.532v-.003a.532.532 0 00-.532-.532z"
                fill="#FFC78A"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.644 25.51l-.674 1.156a.267.267 0 00.365.364l1.155-.674-.846-.846zM6.038 24.838l1.124 1.124c.083.083.21.102.314.047a12.988 12.988 0 003.152-2.315l5.8-5.8-2.322-2.322-5.8 5.8a12.987 12.987 0 00-2.315 3.152.267.267 0 00.047.314zM16.961 17.361a.267.267 0 00.377 0l1.329-1.36c7.467-7.468 8-9.334 7.333-10-.666-.668-2.533-.134-10 7.332l-1.36 1.329a.267.267 0 000 .377l2.321 2.322z"
                fill="#fff"
            />
        </g>
        <defs>
            <linearGradient
                id="prefix__paint0_linear_56_33"
                x1={16}
                y1={31.703}
                x2={16}
                y2={1.331}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FB8517" />
                <stop offset={1} stopColor="#FFB62D" />
            </linearGradient>
        </defs>
    </AccessibleSVG>
);

export default PagesForMac32;
